// extracted by mini-css-extract-plugin
export default {"root":"SeatReservationDialog_root__KxO4J","actions":"SeatReservationDialog_actions__ad6lk"};